import 'regenerator-runtime/runtime';
import {
  call, put, fork, select, takeEvery,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as constants from 'constants/redux/conversations';
import * as actionCreators from 'actions/conversations';
import api from '../api';

function* fetchConversationsRequest() {
  const maxTryAgain = 3;
  for (let i = 1; i <= maxTryAgain; i++) {
    try {
      const { limit, offset, filter } = yield select((state) => ({
        limit: state.conversations.limit,
        offset: state.conversations.offset,
        filter: state.conversations.filter,
      }));
      const conversations = yield call(api.fetchConversations.bind(null, limit, offset, filter));
      yield put(actionCreators.fetchConversationsSuccess(conversations));
      return;
    } catch (e) {
      if (i === maxTryAgain || e.status === 401) {
        if (e.status === 401) {
          yield [
            put(actionCreators.fetchConversationsFailure({ error: {} })),
          ];
        } else {
          yield put(actionCreators.fetchConversationsFailure({
            error: {
              status: e.status,
              message: 'Could not load conversations.',
              canTryAgain: true,
            },
          }));
        }
        return;
      }
      yield call(delay, 2000);
    }
  }
}

export default [
  fork(takeEvery, constants.FETCH_CONVERSATIONS_REQUEST, fetchConversationsRequest),
];
